import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    close: {
      main: "#fff"
    }
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          title: "p",
          modal: "p",
          body2:"p"
        },
      },
      styleOverrides: {
        title: {
          color: "#fff",
        },
        modal: {
          color: "#fff",
        },
        body2: {
          color: "#fff",
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          color: '#fff'
        }
      }
    },

    MuiChip: {
      styleOverrides: {
        filled: {
          background: "#fff",
          color: "#000000",
          "&:hover" :{
            backgroundColor:'#fff'
          }
        },
        outlined: {
          backgroundColor: "inherit",
          border: "none",
          color:'#fff',
        },
      },
    },
  },
});

export default theme;
